import { ContentCopy } from "@mui/icons-material";
import { Box, CardMedia, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import VideoDetailsCard from "./VideoDetailsCard";
import VideoSuggestion from "./VideoSuggestion";
import { AppActionButton } from "../../../ImageSuite/Components/Shared/AppActionButton";
import { useAppSelector } from "../../../../store/hooks";
import { VideoModalData, VideoSettings } from "../../../../Types/VideoSuite-Types";
import { formatDateTime } from "./helper";
import SignalRService from "../../../one-query/services/SignalRService";
import { useGetVideoSuiteApps, useGetVideoSuiteAppSettings, useRegenerateVideo } from "../../../../store/Apis/SuitesApps/VideoSuiteApi";
import { convertUtcToLocalDateTime } from "../../../../store/one-query/useMethodHelper";
import { getVideoSuiteHistoryAppIcon } from "./VideoSuiteHistoryDetailsModal";
interface VideoDetailsProps {
  videoDetailsData: VideoModalData;
  handleRegenerateVideo: () => void;
  isRegenerateLoading: boolean;
  btnActionText?: string;
}

const VideoDetails = ({
  videoDetailsData,
  handleRegenerateVideo,
  isRegenerateLoading,
  btnActionText = "Regenerate",
}: VideoDetailsProps) => {
  const appSuiteCosts = useAppSelector((s) => s.User.AppSuiteCosts);
  const [appId,setAppId]=useState("")
   const { refetch: GetVideoSuiteApps, data: videoSuiteAppsData } =
   useGetVideoSuiteApps();
  const { data: videoSuiteAppSettings } = useGetVideoSuiteAppSettings(appId);
  
  useEffect(() => {
    GetVideoSuiteApps();
  }, []);
  
  useEffect(() => {
    if (!window.location.pathname.includes("/library") && videoDetailsData?.id.length > 0 ) {
      setAppId(videoSuiteAppsData?.find((app:any)=>app.name===videoDetailsData.appType).id)
    }
  }, [videoSuiteAppsData, window.location.pathname]);
  const showCreditsNeeded = !window.location.pathname.includes("library/video");
  const creditsNeeded = showCreditsNeeded &&
        videoSuiteAppSettings?.find(
          (model: VideoSettings) => model.name === videoDetailsData?.settings?.model
    )?.creditsNeeded
  
  return (
    <Box
      sx={{
        p: 1,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      {/* header */}
      <Box
        sx={{
          pb: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box className="video-footer-left">
          <Box
            className="circle-icon"
            sx={{
              backgroundColor: "rgba(18, 182, 234, 0.50)",
              width: "24px",
              height: "24px",
            }}
          >
            {getVideoSuiteHistoryAppIcon(videoDetailsData.appType)}
          </Box>
          <Typography className="shared-typography shared-typography-color  shared-typography-modal">
            {videoDetailsData.appType}
          </Typography>
        </Box>
        <Box>
          <Typography
            className="shared-typography shared-typography-color"
            sx={{ opacity: 0.7 }}
          >
            {convertUtcToLocalDateTime(videoDetailsData.createdAt)}
          </Typography>
        </Box>
      </Box>
      {/*  details */}
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          overflowX: "hidden",
          flexGrow: 1,
        }}
        className="details-container-style"
      >
        {/* Details */}
        <VideoDetailsCard
          videoInput={videoDetailsData.input}
          videoSettings={videoDetailsData.settings}
        />
      </Box>

      {/* regenerate button */}
      <Box pt={1}>
        <AppActionButton
          creditsCount={creditsNeeded??appSuiteCosts?.Video ?? 0}
          appMethodFire={handleRegenerateVideo}
          isGenerateButtonDisabled={isRegenerateLoading}
          IsGeneratePromptLoading={isRegenerateLoading}
          inputValue={videoDetailsData.input.prompt}
          btnTitle={btnActionText}
        />
      </Box>
    </Box>
  );
};

export default VideoDetails;
